module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/dropbox-97b5025c9c9fc1dee7049ec8e637487a.svg";